import React, { Component } from 'react';
import   SideNav from "../sidenav/sidenav"
import  AuthService  from "../api/authentication";
// import Category from './category';
import TimeAgo from 'react-timeago'



class  Categories extends Component {

 
    constructor(props){
      super(props)
     //  this.onDelete = this.onDelete.bind(this);
     //  this.onEdit = this.onEdit.bind(this);
     //   this.editSubmit = this.editSubmit.bind(this)
      this.state = {
        isEdit:false,
        getGroup:""
      }
    }
   
    onDelete=()=>{
      const {onDelete , id} = this.props
    //   console.log("id", id)
      onDelete(id)
     
    }

    editpeyer=(event)=>{
      event.preventDefault(); 
      // console.log(" ------------ sedit", this.title.value) 
       const data ={
        name : this.name.value,
        group_id : this.state.getGroup,
        // description:this.description.value ,
        //  id  : this.id.value ,
         id  : this.props.id,
         date : Date.now()
       }
      this.props.editpeyer(data)
      this.setState({isEdit:false})
    }

  showedit=()=>{
      // console.log("-------")
      this.setState({isEdit:true})
  }
  
  close = ()=>{
  //  console.log("-------")
   this.setState({isEdit:false})
  }
  alertClick=(event)=>{
   event.preventDefault();
   this.setState({ 
       alertDelete:true
    });  
 }
 closeOnDelete=( event)=>{
   event.preventDefault();
   this.setState({ 
       alertDelete:false
    });  
 }

 selectCategory = (e)=>{
//   console.log("data--===------> category", e.target.value)
  this.setState({
    getGroup: e.target.value
  })

}

Showcategory= (e)=>{
  e.preventDefault()
  this.setState({
     showCategory: true
  })
}

  

   

    render(){
      if ( this.state.isEdit == false) {
            return(
              this.state.alertDelete?
                  <div className="notification-body-delete">
                    <div className="notification ">
                            <button className="delete" onClick={this.closeOnDelete}></button>
                            <strong>Are you sure to delete this item</strong><br/>
                            <button className="button is-small  is-danger" onClick={this.onDelete}>delete</button>
                    </div>
                    
                </div>
                :
              <li className="table-row">
              
                {/* <div className="col col-1" data-label="Job Id">{this.props.name}</div> */}
                  <div className="col col-2 categoryies-description" data-label="Customer Name">
                    {
                      this.props.category? 
                        <p style={{textTransform:"capitalize"}}>{this.props.category.name}  </p> 
                        :
                        <p>No description</p>
                    }
                       {
                         this.props.category.category?
                          <div>
                            {
                              this.props.category.category.category === false?
                                  <p>No description</p>
                                
                                  :
                                  <p style={{textTransform:"capitalize"}}> Group :{this.props.category.category.name} </p> 
                              }
                                      
                          </div>
                         :
                         <div></div>
                      }

                  
                  
                  </div>
                  {/* <div className="col col-3" data-label="Job Id">  </div> */}
                
                    <p className="payers-body-buttom">
                      <button className="button is-small is-success " onClick={this.showedit}>edit</button>
                      <button className="button is-small  is-danger" onClick={this.alertClick}>delete</button>
                      <br/>
                      {/* < TimeAgo date={this.props.date}  /> */}
                    </p>
                   
                </li>

            )
          }else{
            return (
              <form  onSubmit={this.editpeyer}>
                   <div >
                          <div className="phone-sub-body-form">  
                     
                                <p className="control has-icons-left has-icons-right">
                                                              <input
                                                              // onChange={this.upDatenote}
                                                               ref={ input => this.name = input} 
                                                               defaultValue={ this.props.name}
                                                              className="input" type="tel" 
                                                               placeholder="Category name"/>
                                                              <span className="icon is-small is-left">
                                                              <i className="fas fa-tags">  </i> 
                                                              </span>
                                     </p>
                                 
                              </div>

                              {
                                      this.props.groups?
                                       <div>
                                       {
                                             this.props.groups .length > 0 ? (
                                              <div class="columns">
                                         
                                              <div class="column is-one-third">categoeris:</div>
                                              <div class="column">
                                                <div class="field">
                                                  <div class="control">
                                                    <div class="select is-small">
                                                      <select onChange={this.selectCategory}  class="form-control" value={this.state.getGroup}>
                                                                    {/* <option value={this.state.getfirstCate._id}>{this.state.getfirstCate.name}</option> */}
                                                                    {
                                                                          this.props.groups.map(data => {
                                                                              return  <option key={data._id} value={data._id}>{data.name}</option>
                                                                          })
                                                                      }
                                                                
                                                                            
                                                      </select>
                                                      {/* <select>
                                                        <option value="">--- Please select ---</option>
                                                        <option>With options</option>
                                                      </select> */}
                                                    </div>
                                                  </div>
                                                </div>
                                            </div>
                                          </div>
                                            )
                                         :
                                         <div></div>
                                       }
                                          
            
                                   </div>
                                   :
                                   <div></div>
                                     }

                              {/* <div className="phone-sub-body-form">  
                              <p className="control has-icons-left has-icons-right">
                                                              <input
                                                              // onChange={this.upDatenote}
                                                               ref={ input => this.group = input} 
                                                               defaultValue={ this.props.group_id}
                                                              className="input" type="tel" 
                                                               placeholder="Group number"/>
                                                              
                                     </p>
                                 
                              </div> */}
                          
                         
                            <input className="input" type="hidden" ref={input => this.id = input} defaultValue={ this.props.id} placeholder="More Information"  required/>  
                            <div className="cell-form1">
                               <button className="button is-small is-success button-style" >Save</button>
                               <a className="button is-small is-link " onClick={this.close}>Close</a>
                            </div>
                            <hr/>
                      </div>   
                   
              </form>
            )

      }
       
 



    }






  }


  


export default  Categories;


// WEBPACK FOOTER //
// ./src/component/catalog/categoreis.js